<h1 mat-dialog-title align="center">{{data.header}}</h1>
<div mat-dialog-content [innerHTML]="data.content" align="center" class="pb-20">

</div>
<div mat-dialog-actions align="center">
  <button mat-stroked-button  class= "default-button" *ngIf="data.showCancelBtn" [mat-dialog-close]="false" [mat-dialog-close]>{{data.cancelText}}</button>
  <button mat-raised-button color="accent" *ngIf="data.showLinkBtn" (click)="redirect(data.redirectLink)" cdkFocusInitial>{{data.confirmText}}</button>
</div>